//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueFlip from 'vue-flip'
import { Feedback } from '@/utils/notify-toaster.js'
export default {
  name: 'LoginScreenCard',
  components: {
    'vue-flip': VueFlip
  },
  mounted: function () { },
  data() {
    return {
      userInfo: {
        email: '',
        password: ''
      },
      loading: false,
      mode: 'login',
      formIsValid: true,
      error: null,
      actionPayload: {},
      isPwd: true,
      flipped: false,
      csscardWarning: false
    }
  },
  computed: {
    //Computed para fazer a alteração entre recover e login TODO
    submitButtonCaption() {
      if (this.mode === 'login') {
        return 'Login'
      } else {
        return 'Recover'
      }
    },
    switchModeButtonCaption() {
      if (this.mode === 'login') {
        return 'login'
      } else {
        return 'recover'
      }
    },
    isLoggedIn() {
      return this.$store.getters.isAuthenticated
    },
    didAutoLogout() {
      return this.$store.getters.didAutoLogout
    }
  },
  methods: {
    async loginFunction() {
      return await this.$store.dispatch('login', this.actionPayload)
    },
    async recoverFunction() {
      return await this.$store.dispatch('recover', this.actionPayload)
    },
    async submitForm() {
      this.formIsValid = true
      if (this.mode === 'login') {
        if (
          this.userInfo.email === '' ||
          !this.userInfo.email.includes('@') ||
          this.userInfo.password === ''
        ) {
          this.formIsValid = false
          return
        }
        this.loading = true

        this.actionPayload = {
          email: this.userInfo.email,
          password: this.userInfo.password
        }
      } else {
        if (!this.userInfo.email.includes('@')) {
          this.formIsValid = false
          return
        }
        this.loading = false

        this.actionPayload = {
          email: this.userInfo.email
        }
      }
      let result
      try {
        if (this.mode === 'login') {
          result = await this.loginFunction()
          if (this.isLoggedIn && result.status == 200) {
            Feedback.success()
            this.$router.push('/')
          } else {
            if (result.data.message == "Erro de ligação ao servidor") {
              this.triggerCssCardError()
              Feedback.error(result.data.message)
            } else if (result.data.message == "Credenciais inválidas") {
              this.triggerCssCardError()
              Feedback.error(result.data.message)
              this.formIsValid = false
            } else {
              this.formIsValid = false
            }
          }
        } else {
          result = await this.recoverFunction()

          if (result.status == 200) {
            Feedback.success(result.data.message)
          } else {
            this.triggerCssCardError()
            Feedback.error(result.response.data.message)
          }
          this.switchAuthMode()
        }
        //Send HTTP Request
      } catch (err) {
        this.triggerCssCardError()
        this.error = err.message || 'Failed to authenticate'
      }
      this.loading = false
    },
    switchAuthMode() {
      this.flipped = !this.flipped
      if (this.mode === 'login') {
        this.mode = 'recover' //TODO
      } else {
        this.mode = 'login'
      }
    },
    triggerCssCardError() {
      this.csscardWarning = true
      setTimeout(() => {
        this.csscardWarning = false
      }, 1000)
    }
  },
  watch: {
    formIsValid: function (newValue) {
      if (newValue == false) {
        this.triggerCssCardError()
        Feedback.error('Por favor, verifique o email e/ou password')
      }
    }
  }
}
